import script from "./CSVViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./CSVViewer.vue?vue&type=script&setup=true&lang=js"

import "./CSVViewer.vue?vue&type=style&index=0&id=5444a604&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5444a604"]])

export default __exports__